import { Inject, Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { catchError, map, withLatestFrom } from 'rxjs/operators';
import { ContactInteractionModel, ContactModel } from '../models/contact.model';
import {
  CONTACTS_REPOSITORY,
  IContactApiProps,
  IContactForm,
  IContactRepository,
  IGenericInteractionProps,
} from '../repositories/IContact.repository';
import { ContactStore } from '../state/contact.store';
import { IContactsService } from './IContact.service';
import {Contacts} from '@capacitor-community/contacts';

@Injectable({
  providedIn: 'root',
})
export class ContactsService
  implements IContactsService<any, ContactModel>
{
  constructor(
    @Inject(CONTACTS_REPOSITORY) private repository: IContactRepository,
    // private nativeContacts: Contacts,
    private store: ContactStore
  ) {}

  loadNativeContacts(filter?: string): Observable<any[]> {
    // const options = new ContactFindOptions();
    // options.multiple = true;
    // options.filter = filter;

    
    const observer: Observable<any[]> = new Observable((subscriber) => {
      try {

        const contacts = Contacts.getContacts({projection: {
          name: true,
          phones: true,
          image: true
          }}).then((_contacts)=>{
            console.log('native contacts: ', _contacts);
          });
         
        subscriber.next([]);
        // this.nativeContacts.find(fields, options).then(
        //   (contacts) => {
        //     subscriber.next(contacts);
        //   },
        //   (error: Error) => {
        //     console.error('*** Device contacts error:', error);
        //     subscriber.error(error);
        //   }
        // );
      } catch (e) {
        console.error(
          '*** TRY/CATCH:: loadRawNativeContacts: Device contacts error:',
          e.message
        );
        subscriber.error('The Contacts Plugin is not installed');
      }
    });

    return observer;
  }

  loadCustomNativeContacts(filter?: string): Observable<ContactModel[]> {
    const observer: Observable<any[]> = new Observable((subscriber) => {
      this.loadNativeContacts(filter)
        .pipe(withLatestFrom(this.store.contacts.data$))
        .subscribe(
          ([contacts, stored]) => {
            subscriber.next(null);
            // const formattedContacts = contacts
            //   .filter((contact) => {
            //     contact.name = contact.name || {
            //       givenName: '',
            //       familyName: '',
            //     };
            //     return (
            //       contact.name.givenName &&
            //       stored.findIndex(
            //         (s) =>
            //           s.phone ===
            //           (contact.phoneNumbers
            //             ? contact.phoneNumbers[0].value
            //             : '')
            //       ) === -1
            //     );
            //   })
            //   .sort((a, b) => a.name.givenName.localeCompare(b.name.givenName))
            //   .map(
            //     (c: Contact) =>
            //       new ContactModel({
            //         id: null,
            //         name: c.name ? c.name.givenName : '',
            //         lastName: c.name ? c.name.familyName : '',
            //         type: 'NOT_SPECIFIED',
            //         email: c.emails ? c.emails[0].value : '',
            //         phone: c.phoneNumbers ? c.phoneNumbers[0].value : '',
            //       })
            //   );
            // subscriber.next(formattedContacts);
          },
          (error: Error) => {
            console.error('****** loadFormatted Device contacts error:', error);
            subscriber.error(error);
          }
        );
    });

    return observer;
  }

  loadFormattedNativeContacts(filter?: string): Observable<ContactModel[]> {
    const observer: Observable<any[]> = new Observable((subscriber) => {
      this.loadCustomNativeContacts(filter)
        .pipe(withLatestFrom(this.store.contacts.data$))
        .subscribe(
          ([contacts, stored]) => {
            subscriber.next(null);
            // const formattedContacts = contacts
            //   .filter((contact) => {
            //     contact.name = contact.name || {
            //       givenName: '',
            //       familyName: '',
            //     };
            //     return (
            //       contact.name.givenName &&
            //       stored.findIndex(
            //         (s) =>
            //           s.phone ===
            //           (contact.phoneNumbers
            //             ? contact.phoneNumbers[0].value
            //             : '')
            //       ) === -1
            //     );
            //   })
            //   .sort((a, b) => a.name.givenName.localeCompare(b.name.givenName))
            //   .map(
            //     (c: Contact) =>
            //       new ContactModel({
            //         id: null,
            //         name: c.name ? c.name.givenName : '',
            //         lastName: c.name ? c.name.familyName : '',
            //         type: 'NOT_SPECIFIED',
            //         email: c.emails ? c.emails[0].value : '',
            //         phone: c.phoneNumbers ? c.phoneNumbers[0].value : '',
            //       })
            //   );
            // subscriber.next(formattedContacts);
          },
          (error: Error) => {
            console.error('****** loadFormatted Device contacts error:', error);
            subscriber.error(error);
          }
        );
    });

    return observer;
  }



  pickOne(phone: string) {
    // const options = new ContactFindOptions();
    // options.multiple = true;

    const fields: Array<any> = ['phoneNumbers'];

    return new Observable((subscriber: Subscriber<any>) => {
      try {
        subscriber.next(null);
        // this.nativeContacts.find(fields, options).then(
        //   (contacts) => {
        //     const res = contacts.filter((c) =>
        //       c.phoneNumbers.some(
        //         (p) => p.value.replace(/[^0-9]+/g, '') === phone
        //       )
        //     );

        //     subscriber.next(res.length > 0 ? res[0] : null);
        //   },
        //   (error: Error) => {
        //     console.error('*** pickOne Device: contacts error:', error);
        //     subscriber.error(error);
        //   }
        // );
      } catch (e) {
        console.error(
          '*** TRY/CATCH:: pickOne: Device contacts error:',
          e.message
        );
        subscriber.error('The Contacts Plugin is not installed');
      }
    });
  }

  loadRawNativeContacts(filter?: string): Observable<any[]> {
    // const options = new ContactFindOptions();
    // options.multiple = true;
    // options.filter = filter;

    
    const observer: Observable<any[]> = new Observable((subscriber) => {
      try {
        subscriber.next(null);
        // this.nativeContacts.find(fields, options).then(
        //   (contacts) => {
        //     subscriber.next(contacts);
        //   },
        //   (error: Error) => {
        //     console.error('*** Device contacts error:', error);
        //     subscriber.error(error);
        //   }
        // );
      } catch (e) {
        console.error(
          '*** TRY/CATCH:: loadRawNativeContacts: Device contacts error:',
          e.message
        );
        subscriber.error('The Contacts Plugin is not installed');
      }
    });

    return observer;
  }
  
  // loadFormattedNativeContacts(filter?: string): Observable<ContactModel[]> {
  //   const observer: Observable<any[]> = new Observable((subscriber) => {
  //     this.loadRawNativeContacts(filter)
  //       .pipe(withLatestFrom(this.store.contacts.data$))
  //       .subscribe(
  //         ([contacts, stored]) => {
  //           subscriber.next(null);
  //           // const formattedContacts = contacts
  //           //   .filter((contact) => {
  //           //     contact.name = contact.name || {
  //           //       givenName: '',
  //           //       familyName: '',
  //           //     };
  //           //     return (
  //           //       contact.name.givenName &&
  //           //       stored.findIndex(
  //           //         (s) =>
  //           //           s.phone ===
  //           //           (contact.phoneNumbers
  //           //             ? contact.phoneNumbers[0].value
  //           //             : '')
  //           //       ) === -1
  //           //     );
  //           //   })
  //           //   .sort((a, b) => a.name.givenName.localeCompare(b.name.givenName))
  //           //   .map(
  //           //     (c: Contact) =>
  //           //       new ContactModel({
  //           //         id: null,
  //           //         name: c.name ? c.name.givenName : '',
  //           //         lastName: c.name ? c.name.familyName : '',
  //           //         type: 'NOT_SPECIFIED',
  //           //         email: c.emails ? c.emails[0].value : '',
  //           //         phone: c.phoneNumbers ? c.phoneNumbers[0].value : '',
  //           //       })
  //           //   );
  //           // subscriber.next(formattedContacts);
  //         },
  //         (error: Error) => {
  //           console.error('****** loadFormatted Device contacts error:', error);
  //           subscriber.error(error);
  //         }
  //       );
  //   });

  //   return observer;
  // }

  loadRemoteContacts(): Observable<ContactModel[]> {
    return this.repository.getContacts().pipe(
      map((response) =>
        response.data
          .map((contact) => {
            const contactModel = ContactModel.fromDataResponse(contact);
            return contactModel;
          })
          .sort((a, b) => b.id - a.id)
      ),
      catchError((error) => {
        throw error;
      })
    );
  }

  loadContactInteractions(
    contactId: number
  ): Observable<ContactInteractionModel[]> {
    return this.repository.getContactInteractions(contactId).pipe(
      map((response) =>
        response.data.map((interaction) =>
          ContactInteractionModel.fromDataResponse(interaction)
        )
      ),
      catchError((error) => {
        throw error;
      })
    );
  }

  createContact(form: IContactForm): Observable<ContactModel> {
    return this.repository.createContact(form).pipe(
      map((response) => {
        if (response.data.id) {
          return ContactModel.fromDataResponse(response.data);
        } else {
          throw new Error('Unknown error');
        }
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  delete(contactId: number): Observable<number> {
    return this.repository.delete(contactId).pipe(
      map((response) => {
        if (response.status === 'success') {
          return contactId;
        } else {
          throw Error(JSON.stringify({ statusCode: 500, status: 'error' }));
        }
      }),
      catchError((error) => {
        throw error;
      })
    );
  }

  update(form: IContactForm): Observable<ContactModel> {
    return this.repository.update(form).pipe(
      map((response) => ContactModel.fromDataResponse(response.data)),
      catchError((error) => {
        throw error;
      })
    );
  }

  import(contactList: IContactApiProps[]): Observable<ContactModel[]> {
    return this.repository.import(contactList).pipe(
      map((response) =>
        response.data.contacts_exported.map((c) =>
          ContactModel.fromDataResponse(c)
        )
      ),
      catchError((error) => {
        throw error;
      })
    );
  }

  createInteraction(
    contactId: number,
    config: IGenericInteractionProps
  ): Observable<ContactInteractionModel> {
    return this.repository.createInteraction(contactId, config).pipe(
      map((response) =>
        ContactInteractionModel.fromDataResponse(response.data)
      ),
      catchError((error) => {
        throw error;
      })
    );
  }

  createInteractionPromise( contactId: number,
    config: IGenericInteractionProps): Promise<any> {
    return this.repository
      .createInteraction(contactId, config)
      .pipe(map((response) => response))
      .toPromise();
  }
}
